import { render, staticRenderFns } from "./CreateShipper.vue?vue&type=template&id=31f704c4&"
import script from "./CreateShipper.vue?vue&type=script&lang=js&"
export * from "./CreateShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports